import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Workspace from './pages/Workspace';
import ProjectList from './pages/ProjectList';
import VideoList from './pages/VideoList';
import VideoViewer from './pages/VideoViewer';
import VersionCompare from './pages/VersionCompare';
import Trash from './pages/Trash';
import ClientEnter from './pages/client/ClientEnter';
import ClientFolder from './pages/client/ClientFolder';
import ClientViewer from './pages/client/ClientViewer';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Workspace />} />
        <Route path="/projects/:managerId" element={<ProjectList />} />
        <Route path="/videos/:projectId" element={<VideoList />} />
        <Route path="/viewer/:videoId" element={<VideoViewer />} />
        <Route path="/compare/:videoId" element={<VersionCompare />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/enter" element={<ClientEnter />} />
        <Route path="/client/folder" element={<ClientFolder />} />
        <Route path="/client/viewer/:videoId" element={<ClientViewer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
